import {HTMLAttributes} from 'react'
import {StyledMedicalReportSectionTitle} from './style'

export const MedicalReportSectionTitle = (props: HTMLAttributes<HTMLHeadingElement>) => (
    <StyledMedicalReportSectionTitle {...props} />
)
